
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import vSelect from './vselect'
import common from '@/tools/common'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
Datetime,
XDialog
},
methods: {
ToRule (types) {
try {
this.$router.push({name: 'NodeSearchByDataQuery', query: {code: types}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
ToReport (types) {
try {
console.log(1)
this.$router.push({name: 'NodeSearchByDataQuery', query: {code: types}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
},
data () {
return {
}
},
beforeCreate: function () {
},
async activated () {
let ss = common.getNodeSession()
if (ss && ss.length > 8) {
} else {
this.$vux.alert.show({
title: '请求失败',
content: '您的登录认证已过期，请重新登陆后再试！' })
this.$router.push({name: 'NodeSearchLoginPage', query: {UserType: 'type11'}})
}
}
}



// WEBPACK FOOTER //
// ./src/components/NodeSearchLeaderPage.vue